import { connect } from 'react-redux';
import { getEditorDraft } from '../../../DaEditorWrapper/redux/selectors';
import { getEditorDraft as getEditorDraftNew } from '@wix/da-editor-tiptap/pkg/clientDrafts/selectors';
import { isInitialized, getCommentState } from '../../redux/selectors';
import { generateReplyEditorId } from '../../utils';
import { flagEnabled } from '@wix/da-react-context/pkg/flags/redux/selectors';
const getPropWithSelector = (state, commentId, selector, defaultValue)=>{
    if (isInitialized(commentId)(state)) {
        return selector(commentId)(state);
    }
    return defaultValue;
};
const mapStateToProps = (state, ownProps)=>{
    const isEditorCommentFlagEnabled = flagEnabled(state, 'editor_comment');
    return {
        comment: getPropWithSelector(state, ownProps.comment.commentId, getCommentState, ownProps.comment),
        hasReplyDraft: isEditorCommentFlagEnabled ? !!getEditorDraftNew(state, generateReplyEditorId(ownProps.comment)) : !!getEditorDraft(state, generateReplyEditorId(ownProps.comment))
    };
};
export default connect(mapStateToProps);

//# sourceMappingURL=CommentContextProvider.container.js.map